import React from 'react';
import './Landing.scss';
import '../homepage/homepage.scss';
import Categories from './Categories/Categories';
const Landing = () => {
  return (
    <div className="landing">
       <div className="homepage">
                <h2 className="homeText">O‘zbekiston Respublikasi Adliya vazirligi huzuridagi <br />
                 X.Sulaymonova nomidagi Respublika sud ekspertizasi markazi.</h2>
        </div>
      <Categories/>
    </div>
  );
}

export default Landing;
